<template>
  <div class="information" style="min-height:50vw;">
    <div class="container clearf">
      <div class="left-box">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>农业简讯</el-breadcrumb-item>
        </el-breadcrumb>
        <ul class="info-list">
          <li class="list-style2" v-for="(item,index) in newsList" :key="index">
            <div @click="goDetail(item.tid)" style=" cursor: pointer;">
              <a class="list-title">{{item.title}}</a>
              <div class="style-box clearf">
                <div class="left" v-if="item.coverUrl">
                  <img :src="$img+item.coverUrl" />
                </div>
                <div class="right" :style="{width:item.coverUrl?'calc(100% - 220px)':'100%'}">
                  <p v-if="item.summary">{{item.summary}}</p>

                  <div class="list-bottom">
                    <span>
                      <i class="iconfont icon-shijian"></i>
                      {{item.publishDate}}
                    </span>
                    <span>发布人：{{item.publishByName}}</span>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next,jumper"
          :total="total"
        ></el-pagination>
      </div>
      <div class="right-box">
        <recommendation />
      </div>
    </div>
  </div>
</template>

<script>
import recommendation from "../components/recommendation";
import "@/assets/iconfont/iconfont.css";
export default {
  data() {
    return {
      //分页数据
      currentPage: 1,
      pageSize: 20,
      pageNum: 1,
      total: 0,
      page: 1,
      newsList: []
    };
  },
  components: {
    recommendation
  },
  created() {
    this.getbriefList();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getbriefList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getbriefList();
    },
    goDetail(tid) {
      this.$router.push({
        path: "/informationDetail",
        query: { tid: tid }
      });
    },
    getbriefList: function() {
      let para = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      this.$axios({
        methods: "get",
        url: "/zs/news/newsList",
        params: para
      }).then(res => {
        let newsData = JSON.parse(res.data).respData.content;
        let topNewsData = JSON.parse(res.data).respData;
        this.total = topNewsData.totalElements;
        this.newsList = newsData;
        // console.log(JSON.parse(res.data).respData.content);
      });
    }
  }
};
</script>

<style lang="less">
.left-box {
  float: left;
  width: 848px;
  margin-top: 20px;
  .info-list {
    li {
      position: relative;
      width: 100%;
      background-color: #fff;
      margin-top: 15px;
      padding: 20px;
      .list-title {
        display: block;
        font-size: 18px;
        color: #333;
        font-weight: 700;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 808px;
        cursor: pointer;
        &:hover {
          color: #149508;
        }
      }
      .style-box {
        margin: 10px 0;
        p {
          color: #666;
          line-height: 32px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }
      }
      .left {
        float: left;
        width: 200px;
        height: 133px;
        margin-right: 20px;
      }
      .right {
        float: left;
        width: calc(100% - 220px);
        // width: auto;
      }
      .list-bottom {
        position: absolute;
        bottom: 5px;
        right: 20px;
        color: #999;
        font-size: 14px;
        span {
          margin-left: 30px;
          i {
            margin-right: 5px;
          }
        }
      }
    }
  }
}
.right-box {
  float: right;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/information.vue